module.exports = __webpack_public_path__ + "static/media/microwave2.af56bfad.png";